'use client';

import type { Notebook } from '@repo/api-gw-sdk';
import { useCallback } from 'react';

import { DeleteEntityDialog } from '@/components/lakehouse/deleteEntityDialog';
import { useDAL } from '@/contexts/useDAL';

interface DeleteNotebookDialogProps {
  notebook: Notebook;
  workspaceId: string;
  open: boolean;
  onClose: () => void;
  onDeleted: () => void;
}

export const DeleteNotebookDialog = ({
  notebook,
  workspaceId,
  open,
  onClose,
  onDeleted,
}: DeleteNotebookDialogProps) => {
  const dal = useDAL();

  const handleDelete = useCallback(async () => {
    await dal.lakehouse.deleteNotebook(workspaceId, notebook.id);
    onDeleted();
  }, [dal, workspaceId, notebook.id, onDeleted]);

  return (
    <DeleteEntityDialog
      open={open}
      title='Delete Notebook'
      entityLabel='notebook'
      entityName={notebook.name}
      onClose={onClose}
      onDelete={handleDelete}
      testIdPrefix='confirm-delete-notebook'
    />
  );
};
